<template>
    <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</template>

<script charset="utf-8">

export default {
    name: 'Loading',
    data() {
        return {

        }
    }
}
</script>
